import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component '" + name + "' was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Chad has one of the highest levels of hunger and poverty in the world, which are exacerbated by conflict and climate change. Surrounded by countries affected by violence, Chad suffers from environmental degradation and rapid desertification. `}</p>
    <p>{`Many people depend on farming and livestock for their livelihoods, but climate change poses a serious threat. Meanwhile, the presence of hundreds of thousands of refugees from neighbouring countries has put additional pressure on the country’s already limited resources.`}</p>
    <p>{`The complex nature of these challenges reinforces the importance of developing long-term solutions that address humanitarian as well as development and peacebuilding needs. Thanks to funding from donors like the EU, WFP has been working hard to provide immediate support to the most food insecure while investing in sustainable futures.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      